module.exports = __webpack_public_path__ + "img/icon-search.4ee61553.svg";